// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");

function useClientSizeObserver(ref, onClientSizeChange) {
  React.useEffect((function () {
          var domElem = ref.current;
          if (domElem == null) {
            return ;
          }
          var observer = new ResizeObserver((function (mutations) {
                  if (mutations.length === 0) {
                    return ;
                  }
                  var target = mutations[mutations.length - 1 | 0].target;
                  var clientWidth = target.clientWidth;
                  var clientHeight = target.clientHeight;
                  onClientSizeChange(clientWidth, clientHeight);
                }));
          observer.observe(domElem);
          return (function () {
                    observer.disconnect();
                  });
        }), [ref.current]);
}

exports.useClientSizeObserver = useClientSizeObserver;
/* react Not a pure module */
